import { useExtensionMenuItems } from '../../hooks';

export const ExtensionMenuItems = {
  useExtensionMenuItems,
};

export type ExtensionMenuItemsType = typeof ExtensionMenuItems;
